import { useMutation, useQuery } from '@tanstack/react-query'
import { updateCommonContent, getCommonContent, createFaqCategory, updateFaqCategory, updateFaqCategoryStatus, deleteFaqCategory, getFaqCategory, createFaqQuestion, updateFaqQuestion, updateFaqQuestionStatus, deleteFaqQuestion, getFaqQuestions, uploadFile } from '../api/common'

// Common Content
export const useUpdateCommonContent = () => {
    return useMutation({
        mutationFn: updateCommonContent
    })
};

export const useGetCommonContentQuery = (queryParams = '') => {
    return useQuery({
        queryKey: ['common_content', queryParams],
        queryFn: () => getCommonContent(queryParams),
        enabled: !!queryParams
    });
};

// FAQ Category
export const useGetFaqCategory = (queryParams = '') => {
    return useQuery({
        queryKey: ['faqs_category', queryParams],
        queryFn: () => getFaqCategory(queryParams),
        enabled: !!queryParams
    });
};

export const useCreateFaqCategory = () => {
    return useMutation({
        mutationFn: createFaqCategory
    })
};

export const useUpdateFaqCategory = () => {
    return useMutation({
        mutationFn: updateFaqCategory
    })
};

export const useUpdateFaqCategoryStatus = () => {
    return useMutation({
        mutationFn: updateFaqCategoryStatus
    })
};

export const useDeleteFaqCategory = () => {
    return useMutation({
        mutationFn: deleteFaqCategory
    })
};

// FAQ Questions
export const useGetFaqQuestions = (queryParams = '') => {
    return useQuery({
        queryKey: ['faqs_questions', queryParams],
        queryFn: () => getFaqQuestions(queryParams),
        enabled: !!queryParams
    });
};

export const useCreateFaqQuestion = () => {
    return useMutation({
        mutationFn: createFaqQuestion
    })
};

export const useUpdateFaqQuestion = () => {
    return useMutation({
        mutationFn: updateFaqQuestion
    })
};

export const useUpdateFaqQuestionStatus = () => {
    return useMutation({
        mutationFn: updateFaqQuestionStatus
    })
};

export const useDeleteFaqQuestion = () => {
    return useMutation({
        mutationFn: deleteFaqQuestion
    })
};

// UPLOAD FILE
export const useS3Upload = () => {
    return useMutation({
        mutationFn: uploadFile
    })
}